import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import UserService from "../../services/user.service";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const Home = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();

  useEffect(() => {
    UserService.getPublicContent().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    <Box m={{ xs: "1.5rem", md: "2rem 2.5rem" }} sx={{ maxWidth: "980px" }}>
      <Header title={content.title} subtitle={content.subtitle} />
      {content.content && (
        <Paper
          sx={{
            mt: "2rem",
            p: { xs: "1.5rem", md: "2.25rem" },
            backgroundColor: theme.palette.background.alt,
          }}
        >
          {content.content.split(";").map((text, idx) => (
            <Typography
              key={idx}
              variant="h4"
              fontWeight={400}
              align="justify"
              color={theme.palette.text.primary}
              sx={{ lineHeight: 1.6, mb: idx === content.content.split(";").length - 1 ? 0 : "1.2rem" }}
            >
              {text.trim()}
            </Typography>
          ))}
        </Paper>
      )}
    </Box>
  );
};

export default Home;
